import { CHIP_STATUS } from "@/constants";
import scanStore from "@/store/scanStore";
import { GetLocalStorage } from "@/utils/helper";
import { Image, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const TemplateView = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { chip, template, cusTemplate, scanChip } = scanStore();
  const [isLoading, setIsLoading] = useState(true);

  const serialByParam = searchParams.get("serial");
  const serialByLocalStorage = GetLocalStorage("scan-storage", "serial");
  const serial = serialByParam || serialByLocalStorage || null;

  const fetchSerial = async (serial: string) => {
    setIsLoading(true);
    try {
      await scanChip(serial);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (serial) {
      fetchSerial(serial);
    } else {
      setIsLoading(false);
    }
  }, [serial]);

  useEffect(() => {
    if (isLoading) return;

    if (!chip) {
      navigate("/not-found");
      return;
    }

    switch (chip.status) {
      case CHIP_STATUS.READY:
        navigate("/verify");
        break;
      case CHIP_STATUS.ACTIVATED:
        // Nếu đã có cus_template được publish → xem public view
        if (cusTemplate?.status === "published") {
          navigate("/view");
        } else {
          navigate("/not-configured");
        }
        break;
      case CHIP_STATUS.LOCKED:
      case CHIP_STATUS.DISABLED:
      case CHIP_STATUS.ASSIGNED:
      case CHIP_STATUS.UNASSIGNED:
        navigate("/scan-error");
        break;
      default:
        navigate("/not-found");
        break;
    }
  }, [chip, cusTemplate, isLoading, navigate]);

  if (isLoading) {
    return (
      <section className="container flex items-center justify-center min-h-[50vh]">
        <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
      </section>
    );
  }

  // Hiển thị template cho trạng thái locked
  if (chip?.status === CHIP_STATUS.LOCKED && template) {
    return (
      <section>
        {template.config.banner && (
          <div className="banner">
            <Image
              height={250}
              src={template.config.banner}
              alt="Banner"
              width="100%"
              preview={false}
              className="object-contain"
            />
          </div>
        )}
        <div
          className="p-4 ql-editor"
          dangerouslySetInnerHTML={{ __html: (template.config.content as string) || "" }}
        />
      </section>
    );
  }

  return null;
};

export default TemplateView;
